import { Component, Input, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { ProfileService } from 'src/app/services/profile.service';

// JSON Data
import  *  as  navigationData  from  '../../../assets/json/dashboard-navigation.json';

// Services
//import { HomepageService } from '../homepage.service';


@Component({
  selector: 'apc-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent {
  _navigationSub: any[];
  public navigation;
  public currentTitle;
  public sectionIcon;
  public currentSubtitle;
  public subsectionIcon;
  public urlLength;
  public urlSplitted;
  public isSection: boolean;
  public isSubsection: boolean;
  public navigationSection = (navigationData as any).default;

  @Input() set navigationSub(data: any[]) {
    this._navigationSub = data;
    this.subsection()
  }

  constructor(
    public profileService: ProfileService,
    private router: Router,
    ) {      
      this.section()
    } 

    section() {
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.urlSplitted = event.url.split('/');
          let sectionUrl = event.url.substring(event.url.indexOf('/'));                      
          this.urlLength = this.urlSplitted.length - 1;          
          // if the url contains 'personas' it is treated as if it has the length of one since it is the homepage
          if (this.urlSplitted.length == 3) {            
            this.urlLength = this.urlSplitted[2] == 'personas' ? 1 : 2;
          }          

          this.isSection = this.urlLength > 1;
          // if the url has more than two elements it means than the user is on the subsection page
          this.isSubsection = this.urlLength > 2;

          if (this.isSection) {
            let nav = this.navigationSection.find(el => sectionUrl.includes(el.link));
              this.currentTitle = nav ? nav.title : null;
              this.sectionIcon = nav ? nav.svg : null;
          }

          this.subsection()
        } 
      })
    }

    subsection() {
      if (this.isSubsection && this._navigationSub != undefined) {
        let nav = this._navigationSub.find(el => this.urlSplitted[3].includes(el.link));
        this.currentSubtitle = nav ? nav.title : null;
        this.subsectionIcon = nav ? nav.svg : null;
      }
    }

}